<template>
    <input
    class="form-control
        block w-full px-3 py-2 rounded-lg 
        font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
        border-2 border-skin-b-list-bord 
        hover:bg-skin-b-list-head
        focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0" 
    />
  </template>